export default "__VITE_ASSET__C6oQhBG5__"